import React from "react"
import { IoIosArrowBack } from "react-icons/io"

import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import { blurKeys } from "@fuse/sharedComponents/blurWrapper/blurKeysList"
import { get } from "lodash-es"

import { convertToUTC, getGeneralAddress } from "@fuse/utils/common"

import PreviewDetail from "./PreviewDetail"

const PreviewPage = ({
  isDefaultBg,
  flyerImageUrl,
  formState,
  user,
  timezone,
  onClose,
}) => {
  return (
    <BackgroundWrapper
      //   showImage={!isDefaultBg}
      bgImage={flyerImageUrl}
      className={`max-h-[100vh] h-full overflow-auto touch-manipulation`}
    >
      <BlurWrapper
        blurKey={get(blurKeys, "mainBlurView")}
        overlayOpacityDefault={isDefaultBg ? "0" : "75"}
        overlayColorDefault="dark"
        className={`bg-gray-400/10 h-[10vh] flex flex-row  items-center px-6  top-0 left-0 w-full z-10 fixed `}
      >
        <div
          className="text-white/30 text-base cursor-pointer p-2 bg-white/30 rounded-full"
          onClick={() => {
            onClose()
          }}
        >
          <IoIosArrowBack color={"white"} size={20} />
        </div>
        <div className="text-white text-base cursor-pointer flex-1">
          Preview
        </div>
      </BlurWrapper>

      <div className="flex justify-center flex-col  lg:pt-0 py-0 items-center ">
        <div className="w-full  flex flex-col items-center  justify-center  ">
          <PreviewDetail
            flyerImage={flyerImageUrl}
            isLoggedIn={!!user?.isLoggedIn}
            eventDocData={{
              eventName: formState.eventName,
              eventDescription: formState?.description,
              initiatorAvatarUrl: user?.avatarUrl,
              initiatorName: user?.name,
              timing: {
                eventDate: formState?.startDate,
                eventEndDate: formState?.endDate,
                eventStartTime: convertToUTC(
                  `${formState?.startDate} ${formState?.startTime}`,
                ),
                eventEndTime: convertToUTC(
                  `${formState?.endDate} ${formState?.endTime}`,
                ),
                timeZone: timezone,
                signupCloseDate: convertToUTC(
                  `${formState?.startDate} ${formState?.startTime}`,
                ),
                signupCloseTime: convertToUTC(
                  `${formState?.startDate} ${formState?.startTime}`,
                ),
              },
              location: {
                otherLocationDetails: "",
                radius: 300,
                guestLocationPreview: getGeneralAddress(
                  formState?.location?.nameOfPlace,
                ),
                eventLocation: formState?.location?.nameOfPlace,
                latitude: formState?.location?.lat,
                longitude: formState?.location?.lon,
              },
            }}
            acceptedGuestAvatars={[]}
          />
        </div>
      </div>
    </BackgroundWrapper>
  )
}

export default PreviewPage
